import { HttpErrorResponse, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Applicable, Priority } from "@spartacus/core";

@Injectable({
  providedIn: 'root',
})
export abstract class CustomHttpErrorHandler implements Applicable {

  /**
   * The http response status number which is handled by this handler.
   * Implementations can set the response status number, i.e. 404,
   * so that the handler can be found by the error interceptor.
   */
  responseStatus?: number;

  /**
   * The http response error type (string) which is handled by this handler.
   * Implementations can set the response error type, i.e. TermsAndConditionsNotAcceptedException,
   * so that the handler can be found by the error interceptor.
   */
  responseErrorType?: string;

  /**
   * Handles the error response for the response status that is register for the handler
   * @param { HttpRequest<any> } request : http request
   * @param { HttpErrorResponse } errorResponse : Http error response
   */
  abstract handleError(
    request: HttpRequest<any>,
    errorResponse: HttpErrorResponse
  ): void;

  /**
   * Error handlers are matched by the error `responseStatus` (i.e. 404). On top of the matching status
   * a priority can be added to distinguish multiple handles for the same response status.
   */
  hasMatch(errorResponse: HttpErrorResponse): boolean {
    if (errorResponse) {
      return (errorResponse.status === this.responseStatus || (errorResponse.error.errors != null && errorResponse.error.errors[0].type === this.responseErrorType));
    } else {
      return false;
    }
  }

  abstract getPriority?(): Priority;
}
